import { render, staticRenderFns } from "./airPort.vue?vue&type=template&id=b25b74c0&"
import script from "./airPort.vue?vue&type=script&lang=js&"
export * from "./airPort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b25b74c0')) {
      api.createRecord('b25b74c0', component.options)
    } else {
      api.reload('b25b74c0', component.options)
    }
    module.hot.accept("./airPort.vue?vue&type=template&id=b25b74c0&", function () {
      api.rerender('b25b74c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/airPort.vue"
export default component.exports